const isDevelopment = process.env.NODE_ENV === 'development';
// In production (e.g. Vercel), frontend and backend share the same domain.
// Requests to /api/* are rewritten to the backend serverless function by vercel.json.
// Override via REACT_APP_API_URL if backend is hosted on a separate domain.
const API_URL = process.env.REACT_APP_API_URL || (isDevelopment ? 'http://localhost:5000/api' : '/api');

const getHeaders = () => {
  const token = localStorage.getItem('placementToken');
  return {
    'Content-Type': 'application/json',
    ...(token ? { 'Authorization': `Bearer ${token}` } : {}),
  };
};

const api = {
  // Auth
  login: async (credentials) => {
    const res = await fetch(`${API_URL}/auth/login`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(credentials),
    });
    return res;
  },

  signup: async (data) => {
    const res = await fetch(`${API_URL}/auth/signup`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data),
    });
    return res;
  },

  googleLogin: async (credential) => {
    const res = await fetch(`${API_URL}/auth/google-login`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ credential }),
    });
    return res;
  },

  sendOTP: async (email) => {
    const res = await fetch(`${API_URL}/auth/send-otp`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ email }),
    });
    return res;
  },

  // Progress
  getProgress: async (userId) => {
    const res = await fetch(`${API_URL}/progress?userId=${encodeURIComponent(userId)}`, {
      headers: getHeaders(),
    });
    return res;
  },

  updateProgress: async (data) => {
    const res = await fetch(`${API_URL}/progress`, {
      method: 'POST',
      headers: getHeaders(),
      body: JSON.stringify(data),
    });
    return res;
  },

  resetProgress: async () => {
    const res = await fetch(`${API_URL}/auth/reset-progress`, {
      method: 'POST',
      headers: getHeaders(),
    });
    return res;
  },

  getStats: async (userId) => {
    const res = await fetch(`${API_URL}/progress/stats?userId=${encodeURIComponent(userId)}`, {
      headers: getHeaders(),
    });
    return res;
  },

  // Questions
  getDsaQuestions: async (params) => {
    const query = new URLSearchParams(params).toString();
    const res = await fetch(`${API_URL}/questions/dsa?${query}`, {
      headers: getHeaders(),
    });
    return res;
  },

  getAptitudeQuestions: async (params) => {
    const query = new URLSearchParams(params).toString();
    const res = await fetch(`${API_URL}/questions/aptitude?${query}`, {
      headers: getHeaders(),
    });
    return res;
  },
};

export default api;
